// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "3075cf732a2b2be07f4ac35e859ed0e125fda08c/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};